import React from 'react';
export const DEFAULT_BANNER_PROPS = { show: false, redirectUrl: '', targetType: '' };
export const useSocialBanner = () => {
    const [bannerProps, setBannerProps] = React.useState(DEFAULT_BANNER_PROPS);
    return {
        bannerProps,
        setBannerProps: (newBannerProps) => setBannerProps({ ...DEFAULT_BANNER_PROPS, ...newBannerProps }),
    };
};
//# sourceMappingURL=use-social-banner.js.map